module.exports = __webpack_public_path__ + "media/images/lb/346-9cbaf3d599de33f4fbf9064c7a9dec74.svg";